import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { useTranslation } from "react-i18next";
import { GfUnit } from "@swagger/typescript-fetch-goflyer";

export const useUnitTableColumns = () => {
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "name",
      width: 250,
      headerName: `${t(messages.Name())}`,
    },
    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),
    {
      field: "CreatedBy",
      width: 200,
      headerName: `${t(messages["CreatedBy"]())}`,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<GfUnit>) => {
        const { firstName, lastName, userName, email } =
          params?.row?.adminUser || {};
        const createdBy = firstName
          ? `${firstName} ${lastName || ""}`
          : userName || email || "";
        return <div title={createdBy.trim()}>{createdBy}</div>;
      },
    },
    {
      field: "id",
      width: 300,
      headerName: `${t(messages["id"]())}`,
      filterable: false,
    },
  ];

  return columns;
};
